import { FC } from 'react';
import { CreateMemorialQuiltStepOneProps } from './model';
import { ReflectingSection } from './components/ReflectingSection';
import { isVac } from 'utilities/is-vac';
import { FormVac } from './components/FormVac';
import { FormMemorial } from './components/FormMemorial';
import styles from './styles.module.scss';

export const CreateMemorialQuiltStepOne: FC<CreateMemorialQuiltStepOneProps> = ({
  isStepOneUpdated,
  isActiveStep,
  steps
}) => {
  return (
    <div className={`center ${styles.firstBlock}`}>
      <ReflectingSection />

      {isVac() ? (
        <FormVac 
          isStepOneUpdated={isStepOneUpdated}
          isActiveStep={isActiveStep}
          steps={steps}
        />
      ) : (
        <FormMemorial 
          isStepOneUpdated={isStepOneUpdated}
          isActiveStep={isActiveStep}
          steps={steps}
        />
      )}
    </div>
  );
};
